import humps from 'humps'

import { stadiumApi } from 'store/stadiumApi'

import {
  TPosAccount,
  TPosAccountResponse,
  TCreatePosAccount,
  TCreatePosAccountResponse,
  TEditPosAccount,
} from 'types/posAccounts'

const posAccounts = stadiumApi.injectEndpoints({
  endpoints: (builder) => ({
    getPosAccounts: builder.query<TPosAccount[], { orgName: string }>({
      async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
        const { orgName } = _arg

        const accounts = await fetchWithBQ(`operator/attendants?organization_name=${orgName}`)
        const allAccountData = accounts?.data as TPosAccountResponse
        const allAccounts: TPosAccount[] = allAccountData?.attendants

        return { data: allAccounts ?? [] }
      },
      providesTags: ['PosAccounts'],
    }),

    createPosAccount: builder.mutation<TCreatePosAccountResponse, TCreatePosAccount>({
      query: (data) => ({
        url: '/operator/attendants',
        method: 'POST',
        body: {
          attendants: [humps.decamelizeKeys(data)],
        },
      }),
      invalidatesTags: ['PosAccounts'],
    }),
    updatePosAccount: builder.mutation<TCreatePosAccountResponse, TEditPosAccount>({
      query: (params) => {
        return {
          url: `/operator/attendants`,
          method: 'PUT',
          body: {
            attendants: [humps.decamelizeKeys(params)],
          },
        }
      },
      invalidatesTags: ['PosAccounts'],
    }),
  }),
})

export const { useGetPosAccountsQuery, useCreatePosAccountMutation, useUpdatePosAccountMutation } =
  posAccounts
